import React from 'react'
import PropTypes from 'prop-types'

import {
  titleMsg,
  tryAgainMsg,
} from './ErrorView.messages'
import style from './ErrorView.less'

const ErrorView = () => {
  return (
    <div className={style.container} data-test="errorView">
      <h1 className={style.heading}>{titleMsg}</h1>
      <p className={style.message}>{tryAgainMsg}</p>
      <div>
        <img src="https://static.r2r.io/images/logo240px.png" className={style.logo} alt="logo" />
      </div>
    </div>
  )
}

ErrorView.propTypes = {
  error: PropTypes.instanceOf(Error),
}

export default ErrorView
